import React from 'react';

export const SendMessageIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    width='13'
    height='12'
    viewBox='0 0 13 12'
    fill='none'
  >
    <path
      d='M12.2845 5.39678L0.95116 0.0634447C0.837037 0.00974487 0.710023 -0.01048 0.584866 0.00511857C0.459709 0.0207172 0.341544 0.0714993 0.244093 0.151568C0.146643 0.231637 0.0739048 0.337707 0.0343255 0.457461C-0.00525383 0.577215 -0.0100504 0.70574 0.0204929 0.828111L0.828493 4.06078L6.00049 6.00011L0.828493 7.93945L0.0204929 11.1721C-0.0106251 11.2946 -0.00622883 11.4234 0.0331674 11.5434C0.0725636 11.6635 0.145331 11.7698 0.242957 11.85C0.340584 11.9303 0.459032 11.981 0.584448 11.9964C0.709864 12.0117 0.837061 11.9911 0.95116 11.9368L12.2845 6.60344C12.399 6.54961 12.4959 6.46428 12.5637 6.35744C12.6315 6.2506 12.6676 6.12667 12.6676 6.00011C12.6676 5.87356 12.6315 5.74962 12.5637 5.64278C12.4959 5.53594 12.399 5.45062 12.2845 5.39678Z'
      fill='white'
    />
  </svg>
));

SendMessageIcon.displayName = 'SendMessageIcon';
